<template>
	<div id='DataDiv'>
		<v-Head></v-Head>
		<v-Sidebar @getinfo=typess></v-Sidebar>
		<div v-if="maintype==1">
         <div class="content-box" :class="{'content-collapse':collapse}">
			<transition name="move" mode="out-in">
				<keep-alive :include="tagsList">
					<router-view></router-view>
				</keep-alive>
			</transition>
			<el-backtop></el-backtop>
		</div>
		</div>
		<div v-else>
           <div class="content-box content-boxs" :class="{'content-collapse':collapse}">
			<transition name="move" mode="out-in"> 
				<keep-alive :include="tagsList">
					<router-view></router-view>
				</keep-alive>
			</transition>
			<el-backtop></el-backtop>
		</div>
		</div>
	</div>
</template>
<script>
	import vHead from './header.vue';
	import vSidebar from './sidebars.vue';
	export default {
		components: {
			vHead,
			vSidebar,
		},
		data() {
			return {
				tagsList: [],
				collapse: false,
				maintype:1,
			}
		},
		methods:{
			typess(res){
				 this.maintype=res
			}
		},
		mounted() {
			if (window.sessionStorage.getItem('admincrm') != '' && window.sessionStorage.getItem('admincrm') != undefined) {
				  let path=window.sessionStorage.getItem('path')
				 if(path!=''&&path!=undefined&&path!=null){
					  this.$router.push({
					path: '/'+path,
				   })
				 }else{
					this.$router.push({
						path: '/overview',
					})
				 }
				// this.$router.push({
				// 	path: '/reportlist',
				// })
			} else {
			   this.$router.push({
					path: '/login',
				})
			}
			// if (this.$route.path == '/') {
			// 	this.$router.push({
			// 		path: '/overview',
			// 	})
			// }
			// this.$router.afterEach((to, from, next) => {
			// 	window.scrollTo(0, 0)
			// })
			// $(".content-box").animate({ scrollTop : 0 } , 0)
			// $('#a').scrollTop(0)
			// document.body.scrollTop = document.documentElement.scrollTop = 0;
		}
	}
</script>
<style scoped>
	.content-box {
		min-width: 1200px;
		margin-left: 230px;
	}
	.content-boxs {
		min-width: 1200px;
		margin-left: 90px;
	}
</style>



// WEBPACK FOOTER //
// src/components/comment/shouye.vue